// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "icon-hXRUi";
var _3 = "flights-17uCq";
var _4 = "flight-3KRxp";
var _5 = "flight_icon-3IFOj";
var _6 = "flight_count-1SI2w";
var _7 = "flight_info-2rKG-";
var _8 = "flight_direction-2kB6e";
var _9 = "flight_deleteButton-3kAux";
export { _1 as "__esModule", _2 as "icon", _3 as "flights", _4 as "flight", _5 as "flight_icon", _6 as "flight_count", _7 as "flight_info", _8 as "flight_direction", _9 as "flight_deleteButton" }
export default { "__esModule": _1, "icon": _2, "flights": _3, "flight": _4, "flight_icon": _5, "flight_count": _6, "flight_info": _7, "flight_direction": _8, "flight_deleteButton": _9 }
